import type { Job } from '#shared/types/Job'
import { JobPlaceType } from '#shared/types/Job'

type JobCardFields = Pick<Job, 'jobPlace' | 'jobLocation' | 'salaryMin' | 'salaryMax' | 'salaryUnit'>

/**
 * Short place label for compact job cards, e.g. "Remote / Košice".
 */
export function formatJobPlaceShort(job: Partial<JobCardFields>): string {
    const remote = job.jobPlace?.includes(JobPlaceType.homeoffice)
    const location = job.jobLocation?.join(', ')
    if (remote && location) return `Remote / ${location}`
    if (remote) return 'Remote'
    return location || ''
}

/**
 * Short salary label for compact job cards, e.g. "25–46 €/h" or "od 4000 €/mes.".
 */
export function formatJobSalaryShort(job: Partial<JobCardFields>): string {
    const { salaryMin: min, salaryMax: max } = job
    if (!min && !max) return ''
    const unit = job.salaryUnit?.includes('hod') ? '€/h' : '€/mes.'
    if (min && max) return `${min}–${max} ${unit}`
    return min ? `od ${min} ${unit}` : `do ${max} ${unit}`
}
